import { getIsApp } from './AppInfo';
import nonCriticalException from './exceptionLogger';
import { openExternalUrl } from './openExternalUrl';

export const generateSmsUrl = (to?: string, body?: string): string => {
  let url = 'sms:';

  if (to) {
    url += to;
  }

  if (body) {
    // Specially crafted to work on iOS and Android. The semicolon ends the list of phone numbers
    // while he ampersand is used on iOS and the question mark is used on Android as the start
    // of the sequence to add a body. All together this works cross platform.
    url += `;?&body=${encodeURIComponent(body)}`;
  }

  return url;
};

export function sendSMS(
  phoneNumber: string,
  message: string,
  onError?: (err?: any) => void,
): Promise<void> {
  return new Promise<void>((resolve, reject) => {
    if (getIsApp() && window?.sms) {
      window.sms.send(
        phoneNumber,
        message || '',
        { android: { intent: 'INTENT' } },
        resolve,
        reject,
      );
    } else {
      const url = generateSmsUrl(phoneNumber, message || '');
      openExternalUrl(url, '_self');
    }
  }).catch(err => {
    nonCriticalException(err);
    onError?.(err);
  });
}
